import classnames from "classnames";
import isNumber from "lodash/isNumber";
import {FaBan} from "react-icons/fa6";

import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {getPercentageClass} from "@/lib/cssUtils.ts";
import {durationSecFn, percentage} from "@/lib/format.tsx";
import {SLAReport, SLAReportService} from "@/lib/queries/reports.ts";
import {PerformanceDataType} from "@/lib/types/checks.ts";
import {formatResponseTime} from "@/pages/checks/analysis/overview/utils.ts";
import {CheckName} from "@/pages/checks/list/components/CheckName.tsx";

interface SLAReportServiceTableRowProps {
  item: SLAReportService;
  report: SLAReport;
  isInner?: boolean;
}

export const SLAReportServiceTableRow = ({item, report, isInner}: SLAReportServiceTableRowProps) => (
  <tr>
    <td>
      <span className={classnames({"d-block ps-3": isInner})}>
        <CheckName
          id={item.service_id}
          name={item.service_name}
          type={item.monitoring_service_type}
          address={item.device_name}
          textClass="text-primary"
          maxLength={48}
        />
      </span>
    </td>
    {report.show_uptime_sla && <td className="text-center">{percentage(item.uptime_sla)}</td>}
    <td className={classnames(getPercentageClass(item.totals.uptime_pct, item.uptime_sla), "text-center")}>
      {isNumber(item.totals.uptime_pct) ? percentage(item.totals.uptime_pct) : "-"}
    </td>
    <td className="text-center">{item.totals.outages}</td>
    <td
      className={classnames(
        {
          [getPercentageClass(item.totals.uptime_pct, item.uptime_sla)]: item.totals.downtime_secs > 0,
        },
        "text-center"
      )}
    >
      {durationSecFn(item.totals.downtime_secs) || "0h 0m 0s"}
    </td>
    <td className="text-center">
      {[PerformanceDataType.JITTER_DELTA, PerformanceDataType.RESPONSE_TIME, PerformanceDataType.CUSTOM].includes(
        item.performance_data_type
      ) && <span>{formatResponseTime(item.totals.response_time_avg, "-")}</span>}
      {[PerformanceDataType.DAYS_TO_EXPIRY].includes(item.performance_data_type) &&
        !!item.cached_response_time &&
        item.cached_response_time > 0 && <span>Expires: {item.cached_response_time}d</span>}
    </td>
    <td className="justify-items-center">
      {!item.include_in_global_uptime && (
        <TooltipIconRA
          icon={FaBan}
          className="text-muted"
          title="This Check is excluded from the global uptime & downtime calculations above, either due to its Check type, pause state or manual exclusion from metrics."
        />
      )}
    </td>
  </tr>
);
